// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.case-detail-container {
  background: #fff;
}
.case-detail-container .case-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.case-detail-container .case-detail-header .caseheader-label {
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.case-detail-container .case-detail-header .caseheader-label .expandable-case-party-names .case-party-see-more-btn {
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  color: var(--primary-color);
  background-color: transparent;
  border: 1px solid var(--primary-color);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  vertical-align: middle;
}
.case-detail-container .case-detail-header .caseheader-label h3 {
  margin-right: 10px;
  font-weight: 600;
}
.case-detail-container .case-detail-header .caseheader-label .casedetail-label-pill {
  background: green;
  color: white;
  padding: 5px 10px;
  margin-left: 10px;
  border-radius: 4px;
  font-size: 12px;
}
.case-detail-container .case-detail-header .casedetail-edit-btn {
  background: #f1f1f1;
  border: none;
  padding: 6px 6px;
  cursor: pointer;
  border-radius: 50px;
  font-size: 14px;
}
.case-detail-container .casedata-details {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-top: 25px;
}
.case-detail-container .casedata-details .case-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(250px, 1fr));
  gap: 7px;
  padding-inline: 20px;
  padding-bottom: 20px;
  width: 70%;
}
.case-detail-container .casedata-details .case-info-grid > div {
  line-height: 1.3rem;
}
.case-detail-container .casedata-details .case-sidebar {
  float: right;
  background: #e2e8f0;
  padding: 15px;
  border-radius: 6px;
  width: 21%;
  min-width: 100px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info {
  background: white;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header p {
  margin: 0;
  font-size: 14px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header p strong {
  color: #374151;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions {
  display: flex;
  gap: 5px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-edit-icon-btn {
  background-color: #3b82f6;
  color: white;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-edit-icon-btn:hover {
  background-color: #2563eb;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-delete-icon-btn {
  background-color: #ef4444;
  color: white;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-delete-icon-btn:hover {
  background-color: #dc2626;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names {
  color: green;
  font-weight: 500;
  font-size: 0.9rem;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0;
  margin-bottom: 4px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-link {
  cursor: pointer;
  text-decoration: underline;
  flex: 1 1;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-link:hover {
  color: #059669;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .case-delete-user-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 8px;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 10px;
  opacity: 0.7;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .case-delete-user-btn:hover {
  opacity: 1;
  background-color: #dc2626;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container .case-add-assignment-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  align-self: flex-start;
}
.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container .case-add-assignment-btn:hover {
  background-color: #2563eb;
}
.case-detail-container .casedata-details .case-sidebar .casedecison {
  display: flex;
  align-items: center;
}
.case-detail-container .casedata-details .case-sidebar .casedecison p:first-child {
  margin-right: 5px;
}

.appeal-info {
  background: #f4f6f8;
  padding-inline: 20px;
  padding-block: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  justify-content: space-between;
  display: flex;
  align-items: start;
}
.appeal-info .appeal-data .appeal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.appeal-info .appeal-data .appeal-header p {
  margin: 0;
  font-size: 15px;
}
.appeal-info .appeal-data .appeal-header p strong {
  color: #374151;
}
.appeal-info .appeal-data .appeal-header .appeal-actions {
  display: flex;
  gap: 5px;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button.case-edit-icon-btn {
  background-color: #3b82f6;
  color: white;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button.case-edit-icon-btn:hover {
  background-color: #2563eb;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button.case-delete-icon-btn {
  background-color: #ef4444;
  color: white;
}
.appeal-info .appeal-data .appeal-header .appeal-actions button.case-delete-icon-btn:hover {
  background-color: #dc2626;
}
.appeal-info .appeal-data .case-add-appeal-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  align-self: flex-start;
}
.appeal-info .appeal-data .case-add-appeal-btn:hover {
  background-color: #2563eb;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input {
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 12px;
  transition: all 0.2s ease-in-out;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input[readonly] {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
  border-color: #d1d5db;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input[readonly]::placeholder {
  color: #9ca3af;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .appeal-base-date {
  margin-top: 4px;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .appeal-base-date small {
  color: #6b7280;
  font-size: 10px;
  font-style: italic;
  display: block;
  padding: 2px 4px;
  background-color: #f3f4f6;
  border-radius: 3px;
  border-left: 3px solid #3b82f6;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions {
  display: flex;
  gap: 8px;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
  transition: all 0.2s ease-in-out;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-save-icon-btn {
  background-color: #10b981;
  color: white;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-save-icon-btn:hover {
  background-color: #059669;
  transform: translateY(-1px);
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-cancel-icon-btn {
  background-color: #6b7280;
  color: white;
}
.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-cancel-icon-btn:hover {
  background-color: #4b5563;
  transform: translateY(-1px);
}
.appeal-info .appeal-data .appeal-display .appeal-para {
  display: flex;
  gap: 10px;
}
.appeal-info .appeal-data .appeal-display .appeal-para p {
  margin: 4px 0;
  font-size: 14px;
  color: #374151;
}
.appeal-info .appeal-data .appeal-display .appeal-para p strong {
  color: #1f2937;
}
.appeal-info .appeal-data .appeal-display .appeal-para p:last-child {
  color: #059669;
  font-weight: 500;
}
.appeal-info .appeal-data .appeal-display p {
  margin: 4px 0;
  font-size: 14px;
  color: #374151;
}
.appeal-info .appeal-data .appeal-display p strong {
  color: #1f2937;
}
.appeal-info .appeal-data .appeal-display p:last-child {
  color: #059669;
  font-weight: 500;
}
.appeal-info .appeal-data .appeal-display .calculated-date {
  position: relative;
}
.appeal-info .appeal-data .appeal-display .calculated-date::after {
  content: "📅";
  font-size: 10px;
  margin-left: 4px;
  opacity: 0.7;
}
.appeal-info .appeal-information {
  font-size: 0.8rem;
  padding: 7px;
  background-color: white;
}

.case-detail-status-pending {
  color: #da5c19;
}
.case-detail-status-case-disposed {
  background-color: #f0f0f0;
  color: #888;
  pointer-events: none;
  cursor: not-allowed;
  padding: 0px 5px;
  border-radius: 5px;
  display: inline-block;
  font-size: 12px;
}

@media (max-width: 1024px) {
  .case-detail-container .casedata-details {
    flex-direction: column;
    align-items: stretch;
  }
  .case-detail-container .casedata-details .case-info-grid {
    width: 100%;
    grid-template-columns: 1fr;
    padding: 10px;
  }
  .case-detail-container .casedata-details .case-sidebar {
    width: 100%;
    margin-top: 20px;
    float: none;
  }
  .case-detail-container .case-detail-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .case-detail-container .case-detail-header .caseheader-label {
    flex-wrap: wrap;
    padding: 10px;
  }
  .case-detail-container .case-detail-header .caseheader-label h3 {
    margin-bottom: 10px;
  }
  .case-detail-container .case-detail-header .caseheader-label .casedetail-label-pill {
    margin-top: 5px;
    margin-left: 0;
    margin-right: 10px;
  }
  .case-detail-container .case-detail-header .casedetail-edit-btn {
    margin-top: 10px;
    align-self: flex-end;
  }
}
@media (max-width: 600px) {
  .case-detail-container {
    padding: 10px;
  }
  .case-detail-container .case-detail-header .caseheader-label h3 {
    font-size: 16px;
  }
  .case-detail-container .case-detail-header .casedetail-label-pill {
    font-size: 10px;
    padding: 4px 8px;
    height: auto;
    width: auto;
  }
  .case-detail-container .case-detail-header .casedetail-edit-btn {
    font-size: 12px;
    padding: 4px 10px;
  }
  .case-detail-container .case-info-grid {
    font-size: 14px;
  }
  .case-detail-container .case-sidebar {
    font-size: 14px;
  }
  .case-detail-container .case-sidebar .assignment-info .assignment-header,
  .case-detail-container .case-sidebar .assignment-info .appeal-header,
  .case-detail-container .case-sidebar .appeal-info .assignment-header,
  .case-detail-container .case-sidebar .appeal-info .appeal-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-input-group .case-appeal-input,
  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-input-group .case-appeal-input {
    font-size: 14px;
    padding: 8px;
  }
  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-input-group .appeal-base-date small,
  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-input-group .appeal-base-date small {
    font-size: 11px;
  }
  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-edit-actions,
  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-edit-actions {
    flex-direction: row;
    justify-content: center;
  }
  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-edit-actions button,
  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-edit-actions button {
    width: 40px;
    height: 28px;
  }
}
.office-ref {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.case-office-ref-container .case-add-office-ref-btn {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.75rem;
  cursor: pointer;
}
.case-office-ref-container .case-add-office-ref-btn:hover {
  background-color: #3c5ce6;
}
.case-office-ref-container .case-office-ref-edit,
.case-office-ref-container .case-office-ref-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-input,
.case-office-ref-container .case-office-ref-display .case-office-ref-input {
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--border-light);
  border-radius: 4px;
  font-size: 0.875rem;
  flex: 1 1;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions {
  display: flex;
  gap: 0.25rem;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.75rem;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-save-icon-btn,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-save-icon-btn {
  background-color: var(--success-color);
  color: white;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-edit-icon-btn,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-edit-icon-btn {
  background-color: #3b82f6;
  color: white;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-delete-icon-btn,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-delete-icon-btn {
  background-color: #ef4444;
  color: white;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-cancel-icon-btn,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-cancel-icon-btn {
  background-color: var(--text-light);
  color: white;
}
.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button:hover,
.case-office-ref-container .case-office-ref-display .case-office-ref-actions button:hover {
  opacity: 0.8;
}

.no-data-message {
  text-align: center;
  padding: 20px;
  color: #6b7280;
}
.no-data-message h3 {
  color: #374151;
  margin-bottom: 10px;
}
.no-data-message p {
  font-size: 14px;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/pages/CaseDetails/CaseDetails.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAEE,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACN;AACQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,6BAAA;EACA,sCAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AACV;AAGM;EACE,kBAAA;EACA,gBAAA;AADR;AAIM;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAFR;AAQI;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AANN;AAUE;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AARJ;AAUI;EACE,aAAA;EACA,oDAAA;EACA,QAAA;EACA,oBAAA;EACA,oBAAA;EAEA,UAAA;AATN;AAWM;EACE,mBAAA;AATR;AAaI;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAXN;AAaM;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;AAXR;AAaQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAXV;AAaU;EACE,SAAA;EACA,eAAA;AAXZ;AAaY;EACE,cAAA;AAXd;AAeU;EACE,aAAA;EACA,QAAA;AAbZ;AAeY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAbd;AAec;EACE,yBAAA;EACA,YAAA;AAbhB;AAegB;EACE,yBAAA;AAblB;AAiBc;EACE,yBAAA;EACA,YAAA;AAfhB;AAiBgB;EACE,yBAAA;AAflB;AAsBQ;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AApBV;AAsBU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;AApBZ;AAsBY;EACE,eAAA;EACA,0BAAA;EACA,SAAA;AApBd;AAsBc;EACE,cAAA;AApBhB;AAwBY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAtBd;AAwBc;EACE,UAAA;EACA,yBAAA;AAtBhB;AA2BU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAzBZ;AA2BY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAzBd;AA2Bc;EACE,yBAAA;AAzBhB;AAkCM;EACE,aAAA;EACA,mBAAA;AAhCR;AAkCQ;EACE,iBAAA;AAhCV;;AAsCA;EACE,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACG,8BAAA;EACD,aAAA;EACA,kBAAA;AAnCJ;AAwCI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAtCN;AAyCM;EACE,SAAA;EACA,eAAA;AAvCR;AAyCQ;EACE,cAAA;AAvCV;AA2CM;EACE,aAAA;EACA,QAAA;AAzCR;AA2CQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAzCV;AA2CU;EACE,yBAAA;EACA,YAAA;AAzCZ;AA2CY;EACE,yBAAA;AAzCd;AA6CU;EACE,yBAAA;EACA,YAAA;AA3CZ;AA6CY;EACE,yBAAA;AA3Cd;AAkDI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAhDN;AAkDM;EACE,yBAAA;AAhDR;AAqDM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAnDR;AAqDQ;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AAnDV;AAqDU;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAnDZ;AAsDU;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AApDZ;AAsDY;EACE,cAAA;AApDd;AAyDQ;EACE,eAAA;AAvDV;AAyDU;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AAvDZ;AA4DM;EACE,aAAA;EACA,QAAA;AA1DR;AA4DQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;AA1DV;AA4DU;EACE,yBAAA;EACA,YAAA;AA1DZ;AA4DY;EACE,yBAAA;EACA,2BAAA;AA1Dd;AA8DU;EACE,yBAAA;EACA,YAAA;AA5DZ;AA8DY;EACE,yBAAA;EACA,2BAAA;AA5Dd;AAoEM;EACE,aAAA;EACA,SAAA;AAlER;AAmEQ;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAjEV;AAmEU;EACE,cAAA;AAjEZ;AAoEU;EACE,cAAA;EACA,gBAAA;AAlEZ;AAsEM;EACE,aAAA;EACA,eAAA;EACA,cAAA;AApER;AAsEQ;EACE,cAAA;AApEV;AAuEQ;EACE,cAAA;EACA,gBAAA;AArEV;AA0EM;EACE,kBAAA;AAxER;AA0EQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAxEV;AA8EG;EACG,iBAAA;EACA,YAAA;EACA,uBAAA;AA5EN;;AAiFE;EACE,cAAA;AA9EJ;AAiFE;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,eAAA;AAhFJ;;AAoFA;EAEI;IACE,sBAAA;IACA,oBAAA;EAlFJ;EAoFI;IACE,WAAA;IACA,0BAAA;IACA,aAAA;EAlFN;EAqFI;IACE,WAAA;IACA,gBAAA;IACA,WAAA;EAnFN;EAuFE;IACE,sBAAA;IACA,uBAAA;EArFJ;EAuFI;IACE,eAAA;IACA,aAAA;EArFN;EAuFM;IACE,mBAAA;EArFR;EAwFM;IACE,eAAA;IACA,cAAA;IACA,kBAAA;EAtFR;EA0FI;IACE,gBAAA;IACA,oBAAA;EAxFN;AACF;AA6FA;EACE;IACE,aAAA;EA3FF;EA8FI;IACE,eAAA;EA5FN;EA+FI;IACE,eAAA;IACA,gBAAA;IACA,YAAA;IACA,WAAA;EA7FN;EAgGI;IACE,eAAA;IACA,iBAAA;EA9FN;EAkGE;IACE,eAAA;EAhGJ;EAmGE;IACE,eAAA;EAjGJ;EAqGM;;;;IAEE,sBAAA;IACA,uBAAA;IACA,QAAA;EAjGR;EAsGU;;IACE,eAAA;IACA,YAAA;EAnGZ;EAuGY;;IACE,eAAA;EApGd;EAyGQ;;IACE,mBAAA;IACA,uBAAA;EAtGV;EAwGU;;IACE,WAAA;IACA,YAAA;EArGZ;AACF;AA6GA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AA3GF;;AAiHE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA9GJ;AAgHI;EACE,yBAAA;AA9GN;AAkHE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;AAhHJ;AAkHI;;EACE,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AA/GN;AAkHI;;EACE,aAAA;EACA,YAAA;AA/GN;AAiHM;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AA9GR;AAgHQ;;EACE,sCAAA;EACA,YAAA;AA7GV;AAgHQ;;EACE,yBAAA;EACA,YAAA;AA7GV;AAgHQ;;EACE,yBAAA;EACA,YAAA;AA7GV;AAgHQ;;EACE,mCAAA;EACA,YAAA;AA7GV;AAgHQ;;EACE,YAAA;AA7GV;;AAuHA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AApHF;AAsHE;EACE,cAAA;EACA,mBAAA;AApHJ;AAuHE;EACE,eAAA;EACA,gBAAA;AArHJ","sourcesContent":["@charset \"UTF-8\";\n.case-detail-container {\n  background: #fff;\n}\n.case-detail-container .case-detail-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.case-detail-container .case-detail-header .caseheader-label {\n  display: flex;\n  align-items: center;\n  padding-left: 20px;\n}\n.case-detail-container .case-detail-header .caseheader-label .expandable-case-party-names .case-party-see-more-btn {\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--primary-color);\n  background-color: transparent;\n  border: 1px solid var(--primary-color);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  vertical-align: middle;\n}\n.case-detail-container .case-detail-header .caseheader-label h3 {\n  margin-right: 10px;\n  font-weight: 600;\n}\n.case-detail-container .case-detail-header .caseheader-label .casedetail-label-pill {\n  background: green;\n  color: white;\n  padding: 5px 10px;\n  margin-left: 10px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n.case-detail-container .case-detail-header .casedetail-edit-btn {\n  background: #f1f1f1;\n  border: none;\n  padding: 6px 6px;\n  cursor: pointer;\n  border-radius: 50px;\n  font-size: 14px;\n}\n.case-detail-container .casedata-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  margin-top: 25px;\n}\n.case-detail-container .casedata-details .case-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(250px, 1fr));\n  gap: 7px;\n  padding-inline: 20px;\n  padding-bottom: 20px;\n  width: 70%;\n}\n.case-detail-container .casedata-details .case-info-grid > div {\n  line-height: 1.3rem;\n}\n.case-detail-container .casedata-details .case-sidebar {\n  float: right;\n  background: #e2e8f0;\n  padding: 15px;\n  border-radius: 6px;\n  width: 21%;\n  min-width: 100px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info {\n  background: white;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header p {\n  margin: 0;\n  font-size: 14px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header p strong {\n  color: #374151;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions {\n  display: flex;\n  gap: 5px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-edit-icon-btn {\n  background-color: #3b82f6;\n  color: white;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-edit-icon-btn:hover {\n  background-color: #2563eb;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-delete-icon-btn {\n  background-color: #ef4444;\n  color: white;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assignment-header .assignment-actions button.case-delete-icon-btn:hover {\n  background-color: #dc2626;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names {\n  color: green;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 0;\n  margin-bottom: 4px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-link {\n  cursor: pointer;\n  text-decoration: underline;\n  flex: 1;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .user-link:hover {\n  color: #059669;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .case-delete-user-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  margin-left: 8px;\n  background-color: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 10px;\n  opacity: 0.7;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .assigned-user-item .case-delete-user-btn:hover {\n  opacity: 1;\n  background-color: #dc2626;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container .case-add-assignment-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  cursor: pointer;\n  align-self: flex-start;\n}\n.case-detail-container .casedata-details .case-sidebar .assignment-info .assigned-names .unassigned-container .case-add-assignment-btn:hover {\n  background-color: #2563eb;\n}\n.case-detail-container .casedata-details .case-sidebar .casedecison {\n  display: flex;\n  align-items: center;\n}\n.case-detail-container .casedata-details .case-sidebar .casedecison p:first-child {\n  margin-right: 5px;\n}\n\n.appeal-info {\n  background: #f4f6f8;\n  padding-inline: 20px;\n  padding-block: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  justify-content: space-between;\n  display: flex;\n  align-items: start;\n}\n.appeal-info .appeal-data .appeal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.appeal-info .appeal-data .appeal-header p {\n  margin: 0;\n  font-size: 15px;\n}\n.appeal-info .appeal-data .appeal-header p strong {\n  color: #374151;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions {\n  display: flex;\n  gap: 5px;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button.case-edit-icon-btn {\n  background-color: #3b82f6;\n  color: white;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button.case-edit-icon-btn:hover {\n  background-color: #2563eb;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button.case-delete-icon-btn {\n  background-color: #ef4444;\n  color: white;\n}\n.appeal-info .appeal-data .appeal-header .appeal-actions button.case-delete-icon-btn:hover {\n  background-color: #dc2626;\n}\n.appeal-info .appeal-data .case-add-appeal-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  cursor: pointer;\n  align-self: flex-start;\n}\n.appeal-info .appeal-data .case-add-appeal-btn:hover {\n  background-color: #2563eb;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input {\n  padding: 6px 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  font-size: 12px;\n  transition: all 0.2s ease-in-out;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input[readonly] {\n  background-color: #f9fafb;\n  color: #6b7280;\n  cursor: not-allowed;\n  border-color: #d1d5db;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .case-appeal-input[readonly]::placeholder {\n  color: #9ca3af;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .appeal-base-date {\n  margin-top: 4px;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-input-group .appeal-base-date small {\n  color: #6b7280;\n  font-size: 10px;\n  font-style: italic;\n  display: block;\n  padding: 2px 4px;\n  background-color: #f3f4f6;\n  border-radius: 3px;\n  border-left: 3px solid #3b82f6;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions {\n  display: flex;\n  gap: 8px;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n  transition: all 0.2s ease-in-out;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-save-icon-btn {\n  background-color: #10b981;\n  color: white;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-save-icon-btn:hover {\n  background-color: #059669;\n  transform: translateY(-1px);\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-cancel-icon-btn {\n  background-color: #6b7280;\n  color: white;\n}\n.appeal-info .appeal-data .appeal-edit-container .appeal-edit-actions button.case-cancel-icon-btn:hover {\n  background-color: #4b5563;\n  transform: translateY(-1px);\n}\n.appeal-info .appeal-data .appeal-display .appeal-para {\n  display: flex;\n  gap: 10px;\n}\n.appeal-info .appeal-data .appeal-display .appeal-para p {\n  margin: 4px 0;\n  font-size: 14px;\n  color: #374151;\n}\n.appeal-info .appeal-data .appeal-display .appeal-para p strong {\n  color: #1f2937;\n}\n.appeal-info .appeal-data .appeal-display .appeal-para p:last-child {\n  color: #059669;\n  font-weight: 500;\n}\n.appeal-info .appeal-data .appeal-display p {\n  margin: 4px 0;\n  font-size: 14px;\n  color: #374151;\n}\n.appeal-info .appeal-data .appeal-display p strong {\n  color: #1f2937;\n}\n.appeal-info .appeal-data .appeal-display p:last-child {\n  color: #059669;\n  font-weight: 500;\n}\n.appeal-info .appeal-data .appeal-display .calculated-date {\n  position: relative;\n}\n.appeal-info .appeal-data .appeal-display .calculated-date::after {\n  content: \"📅\";\n  font-size: 10px;\n  margin-left: 4px;\n  opacity: 0.7;\n}\n.appeal-info .appeal-information {\n  font-size: 0.8rem;\n  padding: 7px;\n  background-color: white;\n}\n\n.case-detail-status-pending {\n  color: #da5c19;\n}\n.case-detail-status-case-disposed {\n  background-color: #f0f0f0;\n  color: #888;\n  pointer-events: none;\n  cursor: not-allowed;\n  padding: 0px 5px;\n  border-radius: 5px;\n  display: inline-block;\n  font-size: 12px;\n}\n\n@media (max-width: 1024px) {\n  .case-detail-container .casedata-details {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .case-detail-container .casedata-details .case-info-grid {\n    width: 100%;\n    grid-template-columns: 1fr;\n    padding: 10px;\n  }\n  .case-detail-container .casedata-details .case-sidebar {\n    width: 100%;\n    margin-top: 20px;\n    float: none;\n  }\n  .case-detail-container .case-detail-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .case-detail-container .case-detail-header .caseheader-label {\n    flex-wrap: wrap;\n    padding: 10px;\n  }\n  .case-detail-container .case-detail-header .caseheader-label h3 {\n    margin-bottom: 10px;\n  }\n  .case-detail-container .case-detail-header .caseheader-label .casedetail-label-pill {\n    margin-top: 5px;\n    margin-left: 0;\n    margin-right: 10px;\n  }\n  .case-detail-container .case-detail-header .casedetail-edit-btn {\n    margin-top: 10px;\n    align-self: flex-end;\n  }\n}\n@media (max-width: 600px) {\n  .case-detail-container {\n    padding: 10px;\n  }\n  .case-detail-container .case-detail-header .caseheader-label h3 {\n    font-size: 16px;\n  }\n  .case-detail-container .case-detail-header .casedetail-label-pill {\n    font-size: 10px;\n    padding: 4px 8px;\n    height: auto;\n    width: auto;\n  }\n  .case-detail-container .case-detail-header .casedetail-edit-btn {\n    font-size: 12px;\n    padding: 4px 10px;\n  }\n  .case-detail-container .case-info-grid {\n    font-size: 14px;\n  }\n  .case-detail-container .case-sidebar {\n    font-size: 14px;\n  }\n  .case-detail-container .case-sidebar .assignment-info .assignment-header,\n  .case-detail-container .case-sidebar .assignment-info .appeal-header,\n  .case-detail-container .case-sidebar .appeal-info .assignment-header,\n  .case-detail-container .case-sidebar .appeal-info .appeal-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-input-group .case-appeal-input,\n  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-input-group .case-appeal-input {\n    font-size: 14px;\n    padding: 8px;\n  }\n  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-input-group .appeal-base-date small,\n  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-input-group .appeal-base-date small {\n    font-size: 11px;\n  }\n  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-edit-actions,\n  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-edit-actions {\n    flex-direction: row;\n    justify-content: center;\n  }\n  .case-detail-container .case-sidebar .assignment-info .appeal-edit-container .appeal-edit-actions button,\n  .case-detail-container .case-sidebar .appeal-info .appeal-edit-container .appeal-edit-actions button {\n    width: 40px;\n    height: 28px;\n  }\n}\n.office-ref {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.case-office-ref-container .case-add-office-ref-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  cursor: pointer;\n}\n.case-office-ref-container .case-add-office-ref-btn:hover {\n  background-color: #3c5ce6;\n}\n.case-office-ref-container .case-office-ref-edit,\n.case-office-ref-container .case-office-ref-display {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-input,\n.case-office-ref-container .case-office-ref-display .case-office-ref-input {\n  padding: 0.25rem 0.5rem;\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  flex: 1;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions {\n  display: flex;\n  gap: 0.25rem;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 18px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.75rem;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-save-icon-btn,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-save-icon-btn {\n  background-color: var(--success-color);\n  color: white;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-edit-icon-btn,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-edit-icon-btn {\n  background-color: #3b82f6;\n  color: white;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-delete-icon-btn,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-delete-icon-btn {\n  background-color: #ef4444;\n  color: white;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button.case-cancel-icon-btn,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button.case-cancel-icon-btn {\n  background-color: var(--text-light);\n  color: white;\n}\n.case-office-ref-container .case-office-ref-edit .case-office-ref-actions button:hover,\n.case-office-ref-container .case-office-ref-display .case-office-ref-actions button:hover {\n  opacity: 0.8;\n}\n\n.no-data-message {\n  text-align: center;\n  padding: 20px;\n  color: #6b7280;\n}\n.no-data-message h3 {\n  color: #374151;\n  margin-bottom: 10px;\n}\n.no-data-message p {\n  font-size: 14px;\n  line-height: 1.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
